import React from 'react'
import Main from '../Main'
import BackToService from './BackToService';

function CurrencyComparison() {
    return (
        <>
            <Main active="service">
                <div className="main">
                    <section>
                        <div className="container section-title">
                            <h2>Currency Comparison <BackToService/></h2>
                        </div>
                    </section>
                </div>
            </Main>
        </>
    )
}

export default CurrencyComparison
